'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417 from "./presto.-Dashboard-View$$anon$17.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024 from "./presto.types$-Dashboard-System-Site-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$16() {
  this.aLg = null;
  this.aL8 = null;
  this.aL9 = false;
  this.aLh = null;
  this.aLi = false;
  this.aLl = null;
  this.aLe = null;
  this.aLf = false;
  this.aLa = null;
  this.aLb = false;
  this.aLc = null;
  this.aLd = false;
  this.aLj = false;
  this.aLk = false;
  this.aLg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLl = "DashboardSystemSiteStats";
}
export { $c_Lpresto_DashboardView$$anon$16 as $c_Lpresto_DashboardView$$anon$16 };
$p = $c_Lpresto_DashboardView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$16;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$16() {
}
export { $h_Lpresto_DashboardView$$anon$16 as $h_Lpresto_DashboardView$$anon$16 };
$h_Lpresto_DashboardView$$anon$16.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aLg;
});
$p.M = (function() {
  if ((!this.aL9)) {
    this.aL8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aL9 = true;
  }
  return this.aL8;
});
$p.O = (function() {
  if ((!this.aLi)) {
    this.aLh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLi = true;
  }
  return this.aLh;
});
$p.E = (function() {
  return this.aLl;
});
$p.t = (function() {
  if ((!this.aLf)) {
    this.aLe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aLf = true;
  }
  return this.aLe;
});
$p.N = (function() {
  if ((!this.aLb)) {
    this.aLa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().va(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aLb = true;
  }
  return this.aLa;
});
$p.Q = (function() {
  if ((!this.aLd)) {
    this.aLc = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417.$c_Lpresto_DashboardView$$anon$17();
    this.aLd = true;
  }
  return this.aLc;
});
$p.v = (function() {
  if ((!this.aLk)) {
    this.aLj = false;
    this.aLk = true;
  }
  return this.aLj;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee75) => ((p) => \u03b4scrutinee75.cFT(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024.$m_Lpresto_types$DashboardSystemSiteStats$())));
});
var $d_Lpresto_DashboardView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$16, "presto.DashboardView$$anon$16", ({
  He: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$16 as $d_Lpresto_DashboardView$$anon$16 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$16.js.map
